import React, { useState } from "react";

function App() {
  const [codigo, setCodigo] = useState("");
  const [imgUrl, setImgUrl] = useState("");
  const [erro, setErro] = useState("");

  const handleBuscar = () => {
    if (!codigo) {
      setErro("Digite o código da imagem.");
      setImgUrl("");
      return;
    }
    const url = `http://cotaseguroviagem.com.br:5300/api/imagem/${encodeURIComponent(
      codigo
    )}`;
    // Testa a existência antes de exibir
    fetch(url)
      .then((resp) => {
        if (!resp.ok) throw new Error("Imagem não encontrada.");
        setImgUrl(url + "?t=" + Date.now()); // força reload caso a mesma imagem seja buscada de novo
        setErro("");
      })
      .catch((e) => {
        setErro(e.message);
        setImgUrl("");
      });
  };

  return (
    <div style={{ maxWidth: 640, margin: "2rem auto", textAlign: "center" }}>
      <h2>Buscar imagem pelo código</h2>
      <input
        value={codigo}
        onChange={(e) => setCodigo(e.target.value)}
        placeholder="Digite o código"
        style={{ width: 200, padding: 8, fontSize: 16 }}
      />
      <button onClick={handleBuscar} style={{ marginLeft: 8, padding: 8 }}>
        Buscar
      </button>
      {erro && <div style={{ color: "red", marginTop: 12 }}>{erro}</div>}
      {imgUrl && (
        <div style={{ marginTop: 20 }}>
          <img src={imgUrl} alt="Imagem" style={{ maxWidth: "100%" }} />
        </div>
      )}
    </div>
  );
}

export default App;
